import { Chip } from '~/shared/ui'
import { GOLD_SET_STATUS_LABELS } from '../config'
import type { GoldSetItemStatus } from '../model'

export function GoldSetStatusChip({ status }: { status: GoldSetItemStatus }) {
  return (
    <Chip
      rounded
      size="sm"
      warning={status === 'todo'}
      success={status === 'done_by_me'}
      info={status === 'done_by_other'}
    >
      {GOLD_SET_STATUS_LABELS[status] ?? status}
    </Chip>
  )
}
